<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"
/>

<div
  class="sidebar-wrapper"
  [ngClass]="{ collapsed: !isSidebarVisible }"
  #sidebarWrapper
>
  <nav class="sidebar">
    <div class="sidebar-header">
      <div class="logo-section">
        <span class="logo-text">Circle Cart App</span>
      </div>
      <button class="toggle-btn" (click)="toggleSidebar()">
        <i
          class="fas"
          [ngClass]="{
            'fa-chevron-left': isSidebarVisible,

            'fa-chevron-right': !isSidebarVisible,
          }"
        ></i>
      </button>
    </div>

    <div class="sidebar-content">
      <ul class="nav-menu">
        <li
          class="nav-item"
          *ngIf="
            authService.isUserLoggedIn() &&
            authService.isUserAdminOrClientAdmin()
          "
          [routerLinkActive]="['active']"
        >
          <a
            class="nav-link"
            [routerLink]="[homeRoute]"
            (click)="!isSidebarVisible && openSidebar()"
          >
            <i class="fas fa-home nav-icon"></i>
            <span class="nav-text">{{
              "i18n.core.navigation.home" | translate
            }}</span>
          </a>
        </li>

        <li
          class="nav-item dropdown"
          *ngIf="authService.isUserAdminOrClientAdmin()"
          [ngClass]="{ expanded: adminMenuOpen }"
        >
          <a
            class="nav-link"
            (click)="!isSidebarVisible ? openSidebar() : toggleAdminMenu()"
          >
            <i class="fas fa-cogs nav-icon"></i>
            <span class="nav-text">{{
              "i18n.core.navigation.administration" | translate
            }}</span>
            <i
              class="fas fa-chevron-right arrow-icon"
              [ngClass]="{ rotated: adminMenuOpen }"
            ></i>
          </a>
          <ul class="sub-menu" [ngClass]="{ show: adminMenuOpen }">
            <li
              class="nav-item"
              *ngIf="
                authService.isUserAdmin() || authService.isUserClientAdmin()
              "
            >
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[clientAdministrationRoute]"
              >
                <i class="fas fa-users-cog nav-icon"></i>
                <span class="nav-text">
                  {{
                    authService.isUserClientAdmin()
                      ? "My Client"
                      : ("i18n.core.navigation.client-administration"
                        | translate)
                  }}
                </span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[userManagementRoute]"
              >
                <i class="fas fa-user-shield nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.user-management" | translate
                }}</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav-item dropdown"
          *ngIf="authService.isUserAdmin()"
          [ngClass]="{ expanded: masterDataMenuOpen }"
        >
          <a
            class="nav-link"
            (click)="!isSidebarVisible ? openSidebar() : toggleMasterDataMenu()"
          >
            <i class="fas fa-database nav-icon"></i>
            <span class="nav-text">{{
              "i18n.core.navigation.master-data" | translate
            }}</span>
            <i
              class="fas fa-chevron-right arrow-icon"
              [ngClass]="{ rotated: masterDataMenuOpen }"
            ></i>
          </a>
          <ul class="sub-menu" [ngClass]="{ show: masterDataMenuOpen }">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[categoryRoute]"
              >
                <i class="fas fa-users nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.category" | translate
                }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[subscriptionRoute]"
              >
                <i class="fas fa-credit-card nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.subscription" | translate
                }}</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[privacypolicyRoute]"
              >
                <i class="fas fa-shield-alt nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.privacy-policy" | translate
                }}</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav-item dropdown"
          *ngIf="authService.isUserLoggedIn()"
          [ngClass]="{ expanded: transactionMenuOpen }"
        >
          <a
            class="nav-link"
            (click)="
              !isSidebarVisible ? openSidebar() : toggleTransactionDataMenu()
            "
          >
            <i class="fas fa-exchange-alt nav-icon"></i>
            <span class="nav-text">{{
              "i18n.core.navigation.Transaction" | translate
            }}</span>
            <i
              class="fas fa-chevron-right arrow-icon"
              [ngClass]="{ rotated: transactionMenuOpen }"
            ></i>
          </a>

          <ul class="sub-menu" [ngClass]="{ show: transactionMenuOpen }">
            <li class="nav-item" *ngIf="authService.isUserAdmin()">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[invoiceRoute]"
              >
                <i class="fas fa-file-invoice nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.Invoices" | translate
                }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[orderRoute]"
              >
                <i class="fas fa-shopping-cart nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.order" | translate
                }}</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!authService.isUserAdmin()">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[deliveryRoute]"
              >
                <i class="fas fa-truck nav-icon"></i>
                <span class="nav-text">
                  {{ "i18n.core.navigation.delivery-details" | translate }}
                </span>
              </a>
            </li>
            <li class="nav-item" *ngIf="!authService.isUserAdmin()">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[productTemplateRoute]"
              >
                <i class="fas fa-cube nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.product-template" | translate
                }}</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="authService.isUserClientAdmin()">
              <a
                class="nav-link"
                [routerLinkActive]="['active']"
                [routerLink]="[salesOverviewRoute]"
              >
                <i class="fas fa-chart-line nav-icon"></i>
                <span class="nav-text">{{
                  "i18n.core.navigation.sales-overview" | translate
                }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="sidebar-footer">
      <!-- <app-language-selector></app-language-selector> -->
      <div class="user-section" *ngIf="authService.isUserLoggedIn()">
        <p-menu #menu [model]="userNavigation" [popup]="true"></p-menu>
        <button
          pButton
          type="button"
          [icon]="userIcon"
          [label]="!isSidebarVisible ? '' : authService.getDisplayName()"
          (click)="menu.toggle($event)"
          class="p-button-text"
        ></button>
      </div>
    </div>
  </nav>
</div>
